import React, { useState } from 'react';
import { NavBar } from 'antd-mobile'

import { 
    BodyView,
    InputView,
    ButtonView
} from "../../factory/ViewUtil";
import { ToastContent, ToastLoading, ToastClear, AlertContent } from '../../factory/FactoryUtil';
import { UpdatePaymentPassword } from '../../../NetworkFactory';

const MePaymentPasswordController = ({goback}) => {

    const [loginPassword, setLoginPassword] = useState('')
    const [paymentPassword, setPaymentPassword] = useState('')

    const PostUpdatePaymentPassword = () => {
        if (loginPassword.length < 6 || loginPassword.length > 20) {
            ToastContent('Login password length [6-20]')
        }
        else if(paymentPassword.length !== 6) {
            ToastContent('Payment password length [6]')
        }
        else {
            if(Number.isNaN(Number(paymentPassword))) {
                ToastContent('Payment password can only be number')
                return
            }
            ToastLoading('Requesting...')
            UpdatePaymentPassword(loginPassword, paymentPassword).then(response => {
                ToastClear()
                const {status} = response.data || {}
                if(status === 200) {
                    ToastContent('Update Success')
                    goback()
                }
                else {
                    AlertContent('Invalid login password or incorrect payment password')
                }
            }).catch(() => {
                ToastClear()
            })
        }
    }

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>Payment Password</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <div style={{height : '20px'}}></div>
                <InputView value={loginPassword} onChange={val => {setLoginPassword(val)}} clearable type="password" title = 'Login password'/>
                <div style={{height : '20px'}}></div>
                <InputView type='number' value={paymentPassword} onChange={val => {setPaymentPassword(val)}} clearable title = 'New payment password'/>
                <ButtonView onClick={PostUpdatePaymentPassword} style = {{width : '100%', marginTop : '15px'}}>Update</ButtonView>
            </BodyView>
        </>
    );
}
export default React.memo(MePaymentPasswordController)